(() => {
  if (customElements.get('sf-product')) return;
  class StoreProduct extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.variants = JSON.parse(this.querySelector('[data-sf-variants]').textContent);
      this.variantInput = this.querySelector('[data-sf-variant-id]');
      this.options = [...this.querySelectorAll('[data-sf-option]')];
      this.quantity = this.querySelector('[name="quantity"]');
      this.buy = this.querySelector('[data-sf-buy]');
      this.dock = this.querySelector('[data-sf-dock]');
      this.setupGallery(signal);
      this.setAttribute('js-ready','');
      this.querySelector('[data-sf-options]')?.removeAttribute('hidden');
      this.addEventListener('change', e => {
        if (e.target.matches('[data-sf-option]')) {
          const values = this.options.map(o => o.value);
          this.selectVariant(this.variants.find(v => v.options.every((value,i) => value === values[i])));
        } else if (e.target === this.variantInput) {
          const variant = this.variants.find(v => String(v.id) === this.variantInput.value);
          variant?.options.forEach((value,i) => { if(this.options[i]) this.options[i].value=value; });
          this.selectVariant(variant);
        } else if (e.target === this.quantity) this.clampQuantity();
      }, {signal});
      this.addEventListener('click', e => {
        const quantityButton=e.target.closest('[data-sf-quantity]');
        if(quantityButton){this.quantity.value=Number(this.quantity.value||this.quantity.min||1)+Number(quantityButton.dataset.sfQuantity)*Number(this.quantity.step||1);this.clampQuantity();}
        const thumb=e.target.closest('[data-sf-thumb]');
        if(thumb)this.showMedia(thumb.dataset.sfThumb);
        if(e.target.closest('[data-sf-return-purchase]')){this.querySelector('.sf-pd-summary').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});this.buy.focus({preventScroll:true});}
      }, {signal});
      const updateDock=()=>{
        if(this.frame)return;
        this.frame=requestAnimationFrame(()=>{this.frame=null;this.positionDock();});
      };
      window.addEventListener('scroll',updateDock,{passive:true,signal});
      window.addEventListener('resize',updateDock,{passive:true,signal});
      this.resizeObserver=new ResizeObserver(updateDock);
      this.resizeObserver.observe(document.querySelector('#MainContent')||this);
      this.clampQuantity();
      this.positionDock();
    }
    disconnectedCallback(){this.controller?.abort();this.resetGallery();this.resizeObserver?.disconnect();cancelAnimationFrame(this.frame);}
    setupGallery(signal){
      this.gallery=this.querySelector('.sf-pd-gallery__stage');
      this.media=[...this.querySelectorAll('[data-sf-media]')];
      this.galleryStatus=this.querySelector('[data-sf-gallery-status]');
      if(!this.gallery)return;
      this.gallery.querySelectorAll('img').forEach(img=>img.draggable=false);
      this.gallery.addEventListener('dragstart',e=>e.preventDefault(),{signal});
      if(this.media.length<2)return;
      this.gallery.classList.add('sf-pd-gallery__stage--swipe');
      this.gallery.addEventListener('pointerdown',e=>this.startGalleryDrag(e),{signal});
      this.gallery.addEventListener('pointermove',e=>this.moveGalleryDrag(e),{passive:false,signal});
      this.gallery.addEventListener('pointerup',e=>{if(this.gesture?.pointerId===e.pointerId)this.finishGalleryDrag();},{signal});
      this.gallery.addEventListener('pointercancel',e=>{if(this.gesture?.pointerId===e.pointerId)this.resetGallery();},{signal});
      this.gallery.addEventListener('lostpointercapture',e=>{if(e.target===this.gallery&&this.gesture?.pointerId===e.pointerId)this.resetGallery();},{signal});
      this.gallery.addEventListener('keydown',e=>{
        if(e.target!==this.gallery||!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
        e.preventDefault();
        const index=this.media.findIndex(m=>!m.hidden&&!m.classList.contains('sf-pd-media--adjacent'));
        const next=e.key==='Home'?0:e.key==='End'?this.media.length-1:(index+(e.key==='ArrowRight'?1:-1)+this.media.length)%this.media.length;
        this.showMedia(this.media[next].dataset.sfMedia);
      },{signal});
      window.addEventListener('resize',()=>this.resetGallery(),{passive:true,signal});
    }
    startGalleryDrag(e){
      if(!e.isPrimary){this.resetGallery();return;}
      if(e.button!==0||!e.target.closest('.sf-pd-image'))return;
      this.resetGallery();
      const index=this.media.findIndex(m=>!m.hidden);
      if(index<0)return;
      this.gesture={pointerId:e.pointerId,index,panel:this.media[index],startX:e.clientX,startY:e.clientY,startTime:performance.now(),width:this.gallery.clientWidth,dx:0,dragging:false};
    }
    moveGalleryDrag(e){
      const g=this.gesture;
      if(!g||g.pointerId!==e.pointerId)return;
      const dx=e.clientX-g.startX,dy=e.clientY-g.startY;
      if(!g.dragging){
        if(Math.max(Math.abs(dx),Math.abs(dy))<8)return;
        // A rolagem vertical continua sendo controlada pelo navegador.
        if(Math.abs(dx)<=Math.abs(dy)*1.2){this.resetGallery();return;}
        g.dragging=true;
        this.gallery.setPointerCapture(e.pointerId);
        this.gallery.classList.add('sf-pd-gallery__stage--dragging');
      }
      e.preventDefault();
      g.dx=Math.max(-g.width,Math.min(g.width,dx));
      const step=g.dx<0?1:g.dx>0?-1:(g.step||1);
      if(step!==g.step){
        this.clearGalleryNeighbor(g.neighbor);
        g.step=step;
        g.nextIndex=(g.index+step+this.media.length)%this.media.length;
        g.neighbor=this.media[g.nextIndex];
        g.neighbor.hidden=false;
        g.neighbor.inert=true;
        g.neighbor.setAttribute('aria-hidden','true');
        g.neighbor.classList.add('sf-pd-media--adjacent');
      }
      g.panel.style.transform=`translateX(${g.dx}px)`;
      g.neighbor.style.transform=`translateX(${g.dx+g.step*g.width}px)`;
    }
    finishGalleryDrag(){
      const g=this.gesture;
      this.gesture=null;
      if(this.gallery.hasPointerCapture(g.pointerId))this.gallery.releasePointerCapture(g.pointerId);
      this.gallery.classList.remove('sf-pd-gallery__stage--dragging');
      if(!g.dragging)return;
      const distance=Math.abs(g.dx),elapsed=Math.max(1,performance.now()-g.startTime);
      const advance=distance>=Math.min(60,Math.max(28,g.width*.12))||(distance>=18&&distance/elapsed>.5);
      const nextId=this.media[advance?g.nextIndex:g.index].dataset.sfMedia;
      if(matchMedia('(prefers-reduced-motion: reduce)').matches){this.showMedia(nextId);return;}
      const endX=advance?-g.step*g.width:0;
      const options={duration:180,easing:'ease-out',fill:'forwards'};
      const token=this.galleryAnimationToken;
      this.galleryAnimations=[
        g.panel.animate([{transform:`translateX(${g.dx}px)`},{transform:`translateX(${endX}px)`}],options),
        g.neighbor.animate([{transform:`translateX(${g.dx+g.step*g.width}px)`},{transform:`translateX(${endX+g.step*g.width}px)`}],options)
      ];
      Promise.all(this.galleryAnimations.map(animation=>animation.finished)).then(()=>{
        if(token===this.galleryAnimationToken)this.showMedia(nextId);
      }).catch(()=>{}); // Troca de variante, redimensionamento ou saída da seção cancela a animação.
    }
    clearGalleryNeighbor(panel){
      if(!panel)return;
      panel.hidden=true;
      panel.inert=false;
      panel.removeAttribute('aria-hidden');
      panel.classList.remove('sf-pd-media--adjacent');
      panel.style.removeProperty('transform');
    }
    resetGallery(){
      const g=this.gesture;
      this.gesture=null;
      if(g&&this.gallery?.hasPointerCapture(g.pointerId))this.gallery.releasePointerCapture(g.pointerId);
      this.galleryAnimationToken=(this.galleryAnimationToken||0)+1;
      this.galleryAnimations?.forEach(animation=>animation.cancel());
      this.galleryAnimations=[];
      this.gallery?.classList.remove('sf-pd-gallery__stage--dragging');
      this.media?.forEach(panel=>{
        if(panel.classList.contains('sf-pd-media--adjacent'))this.clearGalleryNeighbor(panel);
        panel.style.removeProperty('transform');
      });
    }
    clampQuantity(){
      const min=Number(this.quantity.min)||1,step=Number(this.quantity.step)||1,max=this.quantity.max?Number(this.quantity.max):Infinity;
      let value=Math.max(min,Number(this.quantity.value)||min);
      value=min+Math.floor((value-min)/step)*step;
      this.quantity.value=Math.min(max,value);
      this.querySelectorAll('[data-sf-quantity]').forEach(b=>b.disabled=Number(b.dataset.sfQuantity)<0?Number(this.quantity.value)<=min:Number(this.quantity.value)>=max);
    }
    selectVariant(variant){
      this.variantInput.value=variant?String(variant.id):'';
      this.buy.disabled=!variant?.available;
      this.buy.textContent=variant?(variant.available?'COMPRAR':'ESGOTADO'):'INDISPONÍVEL';
      if(!variant){this.querySelector('[ref="liveRegion"]').textContent='Esta combinação não está disponível.';return;}
      this.querySelector('[data-sf-price]').innerHTML=variant.priceHtml;
      this.quantity.min=variant.min;this.quantity.step=variant.step;
      if(variant.max!==null&&variant.max!==undefined)this.quantity.max=variant.max;else this.quantity.removeAttribute('max');
      this.clampQuantity();
      if(variant.mediaId)this.showMedia(variant.mediaId);
      const url=new URL(window.location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
      this.dispatchEvent(new CustomEvent('sf:variant-change',{bubbles:true,detail:{variant}}));
    }
    showMedia(id){
      if(!this.querySelector(`[data-sf-media="${id}"]`))return;
      this.resetGallery();
      this.querySelectorAll('[data-sf-media]').forEach(m=>{m.hidden=String(m.dataset.sfMedia)!==String(id);if(m.hidden){m.querySelectorAll('video').forEach(v=>v.pause());m.querySelectorAll('iframe').forEach(f=>{const url=new URL(f.src);const payload=url.hostname.includes('youtube')?JSON.stringify({event:'command',func:'pauseVideo',args:[]}):{method:'pause'};f.contentWindow?.postMessage(payload,url.origin);});}});
      this.querySelectorAll('[data-sf-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.sfThumb===String(id))));
      if(this.galleryStatus)this.galleryStatus.textContent=`Imagem ${this.media.findIndex(m=>String(m.dataset.sfMedia)===String(id))+1} de ${this.media.length}. Arraste para os lados ou use as teclas de seta.`;
    }
    positionDock(){
      if(!this.dock)return;
      const boundary=document.querySelector('[data-sf-product-end]')||document.querySelector('.sf-footer');
      const end=boundary?.getBoundingClientRect().top??Infinity;
      const pastPurchase=this.buy.getBoundingClientRect().bottom<0;
      this.dock.hidden=!matchMedia('(max-width:989px)').matches||!pastPurchase||end<=0;
      this.dock.style.bottom=Math.max(0,window.innerHeight-end)+'px';
      this.dock.setAttribute('data-at-end',String(end<window.innerHeight));
    }
  }
  customElements.define('sf-product',StoreProduct);
})();
